import { isApiError } from '../api/apiError.js';

export interface FieldErrors {
  /** The message for a field, or `undefined` when it is fine. */
  (path: string): string | undefined;
}

/**
 * Turns an API failure into a lookup a form can consult per field.
 *
 * The server already knows exactly which field it rejected and why; re-deriving
 * that in the browser would only invent a second source of truth.
 */
export function useFieldErrors(error: unknown): FieldErrors {
  if (!isApiError(error)) {
    return () => undefined;
  }

  const byPath = new Map<string, string>();
  for (const detail of error.details) {
    if (!byPath.has(detail.path)) {
      byPath.set(detail.path, detail.message);
    }
  }
  return (path: string) => byPath.get(path);
}
